import {
  Box,
  Heading,
  HStack,
  IconButton,
  Spinner,
  Stack,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { decorators, Treebeard } from 'react-treebeard';
import treeStyles from '../../theme/treeStyles';
import { FaFolderPlus } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { getFolders } from '../../stores/slices/resources/folders/foldersAction';
import FolderForm from './FolderForm';
import { setActiveFolder } from '../../stores/slices/resources/folders/foldersSlice';
import { structureFolderTree } from '../../utils/structureFolderTree';

const Toggle = ({ style }) => {
  return (
    <div style={style.base}>
      <div style={style.wrapper}>
        <svg
          width="9"
          height="15"
          viewBox="0 0 9 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.910097 17.67C0.720097 17.67 0.530098 17.6 0.380098 17.45C0.0900977 17.16 0.0900977 16.68 0.380098 16.39L6.9001 9.87C7.3801 9.39 7.3801 8.61 6.9001 8.13L0.380098 1.61C0.0900977 1.32 0.0900977 0.840004 0.380098 0.550004C0.670098 0.260004 1.1501 0.260004 1.4401 0.550004L7.9601 7.07C8.4701 7.58 8.7601 8.27 8.7601 9C8.7601 9.73 8.4801 10.42 7.9601 10.93L1.4401 17.45C1.2901 17.59 1.1001 17.67 0.910097 17.67Z"
            fill="#00B3B0"
          />
        </svg>
      </div>
    </div>
  );
};
const Folder = props => {
  const { getDisclosureProps, getButtonProps } = useDisclosure();
  const buttonProps = getButtonProps();
  const disclosureProps = getDisclosureProps();
  const { folders, loading, activeFolder } = useSelector(
    state => state.folders
  );
  const [folderTree, setFolderTree] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFolders());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const result = {
      id: 0,
      name: 'My Resources',
      toggled: true,
      active: activeFolder.id === 0,
      children: folders.map(folder =>
        structureFolderTree(activeFolder, folder)
      ),
    };

    setFolderTree(result);
    // eslint-disable-next-line
  }, [folders]);

  const [cursor, setCursor] = useState(false);
  const onToggle = (node, toggled) => {
    if (cursor) {
      cursor.active = false;
    }
    node.active = true;
    if (node.children) {
      node.toggled = toggled;
    }
    setCursor(node);
    setFolderTree(Object.assign({}, folderTree));
    if (node.id !== activeFolder.id)
      dispatch(setActiveFolder(JSON.parse(JSON.stringify(node))));
  };
  return (
    <Box
      minW={'200px'}
      overflow="auto"
      {...props}
      borderRight={'1px'}
      borderColor={'gray.500'}
      pr={'2'}
    >
      <Stack
        justifyContent={'space-between'}
        alignContent={'center'}
        direction={'row'}
        w={'full'}
        spacing={2}
        borderBottom={'1px'}
        borderColor={'gray.500'}
        pt={'1'}
        pb={'3'}
        mb={'4'}
      >
        <HStack>
          <Heading as={'h4'} size="md">
            Folders
          </Heading>
        </HStack>
        <IconButton
          icon={<FaFolderPlus />}
          size={'xs'}
          variant={'outline'}
          color={'primary'}
          borderColor={'primary'}
          title={'Add Folder'}
          {...buttonProps}
        />
      </Stack>
      <Box mb={'3'} {...disclosureProps}>
        <FolderForm buttonProps={buttonProps} />
      </Box>
      {loading ? (
        <Spinner color="primary" />
      ) : (
        <Treebeard
          data={folderTree}
          onToggle={onToggle}
          style={treeStyles}
          decorators={{ ...decorators, Toggle }}
        />
      )}
    </Box>
  );
};

export default Folder;
